(() => {
  if (window.adelaisCollection27) return;
  window.adelaisCollection27 = true;
  let frame, drawer, trigger, reviewTimer;
  function alignTitles() {
    document.querySelectorAll('[data-ac-v27] #CollectionLoop').forEach(grid => {
      const cards = [...grid.children].filter(c => c.matches('.product-item'))
        .map(card => ({card, title: card.querySelector('.product-item__title')})).filter(item => item.title);
      cards.forEach(({title}) => title.style.removeProperty('min-height'));
      const rows = new Map();
      // Finish every layout read before applying any row's new height.
      cards.forEach(({card, title}) => {
        if (!card.getClientRects().length) return;
        const top = Math.round(card.getBoundingClientRect().top);
        if (!rows.has(top)) rows.set(top, []);
        rows.get(top).push({title, height: title.getBoundingClientRect().height});
      });
      rows.forEach(items => {
        const height = Math.max(...items.map(item => item.height));
        items.forEach(({title}) => title.style.minHeight = `${height}px`);
      });
    });
  }
  function schedule() {
    if (frame != null) return;
    frame = requestAnimationFrame(() => { frame = null; alignTitles(); });
  }
  function markSplitCardSwatches(root = document) {
    root
      .querySelectorAll(
        '[data-ac-split-color-card] grid-swatch[data-selected-color]'
      )
      .forEach(gridSwatch => {
        const selectedColor = (
          gridSwatch.dataset.selectedColor || ''
        ).trim().toLowerCase();

        if (!selectedColor) return;

        gridSwatch
          .querySelectorAll('[data-swatch-button]')
          .forEach(button => {
            const swatchColor = (
              button.dataset.tooltip || ''
            ).trim().toLowerCase();

            const link = button.querySelector('[data-swatch-link]');
            if (!link) return;

            const isCurrent = swatchColor === selectedColor;

            link.classList.toggle(
              'sibling__link',
              isCurrent
            );

            link.classList.toggle(
              'sibling__link--current',
              isCurrent
            );

            if (isCurrent) {
              link.setAttribute('aria-current', 'true');
            } else {
              link.removeAttribute('aria-current');
            }
          });
      });
  }

  function init() {
    document.querySelectorAll('[data-ac-v27]').forEach(section => {
      if (section.dataset.ac27Observed) return;
      section.dataset.ac27Observed = 'true';
      let observedGrid;
      let gridWidth;
      const gridObserver = window.ResizeObserver ? new ResizeObserver(entries => {
        const width = entries[0]?.contentRect.width;
        if (width !== gridWidth) { gridWidth = width; schedule(); }
      }) : null;
      const observeGrid = () => {
        const grid = section.querySelector('#CollectionLoop');
        if (grid === observedGrid) return;
        gridObserver?.disconnect();
        observedGrid = grid;
        gridWidth = undefined;
        if (grid) gridObserver?.observe(grid);
      };
      observeGrid();
      new MutationObserver(records => {
        const structural = '.product-item, .product-item__title, #CollectionLoop';
        const affectsTitles = records.some(record => {
          const element = record.target.nodeType === 1 ? record.target : record.target.parentElement;
          if (element?.closest('.product-item__title')) return true;
          if (record.type === 'attributes') return element?.matches('.product-item, #CollectionLoop');
          return [...record.addedNodes, ...record.removedNodes].some(node =>
            node.nodeType === 1 && (node.matches(structural) || node.querySelector(structural)));
        });
        if (affectsTitles) { observeGrid(); schedule(); }
        markSplitCardSwatches(section);
      }).observe(section, { childList:true, subtree:true, characterData:true, attributes:true, attributeFilter:['hidden'] });
      section.addEventListener('load', schedule, true);
      if (window.ResizeObserver) {
        let width;
        new ResizeObserver(entries => {
          const nextWidth = entries[0]?.contentRect.width;
          if (nextWidth === width) return;
          width = nextWidth;
          schedule();
        }).observe(section);
      }
    });
    markSplitCardSwatches(document);
    schedule();
    document.fonts?.ready.then(schedule);
  }
  function createDrawer() {
    drawer = document.createElement('dialog');
    drawer.className = 'ac27-review-drawer';
    drawer.setAttribute('aria-labelledby','ac27-review-heading');
    drawer.innerHTML = '<div class="ac27-review-header"><div><h2 class="ac27-review-heading" id="ac27-review-heading">Customer reviews</h2><p class="ac27-review-product"></p></div><button type="button" class="ac27-review-close" aria-label="Close reviews">×</button></div><div class="ac27-review-body"><p class="ac27-review-loading" role="status">Loading reviews…</p><iframe title="Product reviews"></iframe></div>';
    document.body.append(drawer);
    drawer.querySelector('button').addEventListener('click',()=>drawer.close());
    drawer.addEventListener('click',e=>{if(e.target===drawer){const r=drawer.getBoundingClientRect();if(e.clientY<r.top||e.clientX<r.left||e.clientX>r.right)drawer.close();}});
    drawer.addEventListener('close',()=>{
      clearTimeout(reviewTimer);
      document.documentElement.classList.remove('ac27-reviews-open');
      const iframe=drawer.querySelector('iframe');
      iframe.src='about:blank';
      iframe.style.removeProperty('height');
      trigger?.focus({preventScroll:true});
    });
    drawer.querySelector('iframe').addEventListener('load',()=>{if(drawer.querySelector('iframe').getAttribute('src')==='about:blank')return;clearTimeout(reviewTimer);drawer.querySelector('.ac27-review-loading').hidden=true;});
  }
  window.addEventListener('message',e=>{
    if(!drawer||e.origin!=='https://loox.io')return;
    const iframe=drawer.querySelector('iframe');
    if(!iframe||e.source!==iframe.contentWindow)return;
    let data=e.data;
    if(typeof data==='string'){
      try{data=JSON.parse(data)}catch{return}
    }
    const height=Number(data?.height);
    if(data?.type!=='resize'||data.frame!=='looxReviewsFrame'||!Number.isFinite(height)||height<1)return;
    iframe.style.height=Math.ceil(height)+'px';
  });
  document.addEventListener('click',e=>{
    const button=e.target.closest('[data-ac27-reviews]');
    if(!button) return;
    e.preventDefault(); e.stopPropagation(); trigger=button;
    if(!drawer) createDrawer();
    // Embed Loox's own review endpoint, never a Shopify page (which denies framing).
    // Product-specific requests leave product-group resolution with Loox.
    const productId = button.dataset.productId;
    if (!/^\d+$/.test(productId || '')) return;
    const clientId = window.LOOX?.clientId || 'VyW6e6mGEo';
    const url = new URL('https://loox.io/widget/' + encodeURIComponent(clientId) + '/reviews/' + productId);
    url.searchParams.set('limit', '6');
    url.searchParams.set('thumbnails', 'false');
    if (window.LOOX?.hash) url.searchParams.set('h', window.LOOX.hash);
    if (window.LOOX?.multilingual && window.Shopify?.locale) url.searchParams.set('language', window.Shopify.locale);
    drawer.querySelector('.ac27-review-product').textContent=button.dataset.productTitle || 'Product reviews';
    clearTimeout(reviewTimer);
    const loading = drawer.querySelector('.ac27-review-loading');
    loading.textContent = 'Loading reviews…';
    loading.hidden = false;
    reviewTimer = setTimeout(() => { if(drawer.open && !loading.hidden) loading.textContent = 'Reviews are taking longer to load. Please close and try again.'; }, 12000);
    drawer.querySelector('iframe').src=url.href;
    drawer.showModal();document.documentElement.classList.add('ac27-reviews-open');
    drawer.querySelector('button').focus();
  });
  window.addEventListener('resize',schedule);
  document.addEventListener('shopify:section:load',init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
